import { AuthService } from "../../../services";
import * as CONSTANTS from "./constants";

/*=========== USER EXISTS ===========*/
export const userExists = (data) => async (dispatch, getState) => {
  try {
    const response = await AuthService.userExists(data);
    console.log("userExists response:", response);

    if (response?.success === true) {
      dispatch({
        type: CONSTANTS.USER_EXISTS_SUCCESS,
        payload: response.data || null,
      });
      return response;
    } else {
      dispatch({
        type: CONSTANTS.USER_EXISTS_FAILURE,
        payload: null,
      });
      return response;
    }
  } catch (error) {
    console.error("userExists error:", error);
    dispatch({
      type: CONSTANTS.USER_EXISTS_FAILURE,
      payload: null,
    });
    return { success: false, data: null };
  }
};

/*=========== CREATE NEW USER ===========*/
export const createNewUser = (data) => async (dispatch, getState) => {
  try {
    const response = await AuthService.userCreate(data);
    console.log("createNewUser response:", response);

    if (response?.success === true) {
      dispatch({
        type: CONSTANTS.USER_CREATE_SUCCESS,
        payload: response.data || null,
      });
      return response;
    } else {
      dispatch({
        type: CONSTANTS.USER_CREATE_FAILURE,
        payload: null,
      });
      return response;
    }
  } catch (error) {
    console.error("createNewUser error:", error);
    dispatch({
      type: CONSTANTS.USER_CREATE_FAILURE,
      payload: null,
    });
    return { success: false, data: null };
  }
};

// getSignedGetProfile


export const getSignedGetProfileList = (data) => async (dispatch) => {
  try {
    //  // eslint-disable-next-line no-debugger
    //  debugger;
    const response = await AuthService.getSignedGetProfile(data);

    if (response.success) {
      dispatch({ type: CONSTANTS.GET_PROFILE_SUCCESS, payload: response.data });
      return response;
    } else {

      dispatch({ type: CONSTANTS.GET_PROFILE_FAILURE, payload: null });
      return response;
    }
  } catch (error) {
    console.log(error, "error");
    dispatch({ type: CONSTANTS.GET_PROFILE_FAILURE, payload: null });
    return { success: false, data: null }
  }
}

// GetAgreementsList

export const getAgreementsDetails = ({ status, page, limit }) => async (dispatch) => {
  try {
    console.log("getAgreementsDetails →", { status, page, limit });

    const response = await AuthService.GetAgreementsList(status, page, limit, "");

    if (response?.success === true || response?.status === 200) {
      dispatch({
        type: CONSTANTS.GET_AGREEMENTS_SUCCESS,
        payload: response.data?.agreements || [],
      });
      return response;
    } else {
      dispatch({
        type: CONSTANTS.GET_AGREEMENTS_FAILURE,
        payload: [],
      });
      return response;
    }
  } catch (error) {
    console.error("Get Agreements Error:", error);
    dispatch({
      type: CONSTANTS.GET_AGREEMENTS_FAILURE,
      payload: [],
    });
    return { success: false, data: [] };
  }
};

// saveAgreement

export const createNewSaveAgreement = (data) => async (dispatch) => {
  try {
    const response = await AuthService.saveAgreement(data);
    console.log("saveAgreement response:", response);

    if (response?.success === true) {
      dispatch({
        type: "CREATE_SAVE_AGREEMENT_SUCCESS",
        payload: response.data,
      });
      return response;
    } else {
      dispatch({
        type: "CREATE_SAVE_AGREEMENT_FAILURE",
        payload: null,
      });
      return response;
    }

  } catch (error) {
    dispatch({
      type: "CREATE_SAVE_AGREEMENT_FAILURE",
      payload: null,
    });
    return { success: false };
  }
};

// cancelAgreement

export const cancelAgreementUploadData = (agreementId) => async (dispatch) => {
  try {
    const response = await AuthService.cancelAgreement(agreementId);
    if (response?.success) {
      dispatch({ type: "CANCEL_AGREEMENT_SUCCESS", payload: response.data });
      return response;
    } else {
      dispatch({ type: "CANCEL_AGREEMENT_FAILURE", payload: null });
      return response;
    }
  } catch (error) {
    dispatch({ type: "CANCEL_AGREEMENT_FAILURE", payload: null });
    return { success: false, message: "Cancel failed" };
  }
};

// GetDashboardList

export const getdashboardDetails = () => async (dispatch) => {
  try {
    const response = await AuthService.GetDashboardList();

    if (response?.success === true || response?.status === 200) {
      dispatch({
        type: CONSTANTS.GET_DASHBOARDS_DATA_SUCCESS,
        payload: response.data || response,
      });
      return response;
    } else {
      dispatch({
        type: CONSTANTS.GET_DASHBOARDS_DATA_FAILURE,
        payload: null,
      });
      return response;
    }
  } catch (error) {
    console.error("Get Dashboard Error:", error);
    dispatch({
      type: CONSTANTS.GET_DASHBOARDS_DATA_FAILURE,
      payload: null,
    });
    return { success: false, data: null };
  }
};

/*=========== NEW — GET USER INFO ===========*/
export const getUserInfoList = (lname = "") => async (dispatch) => {
  try {
    const response = await AuthService.getUserInfo(lname);

    if (response?.success) {
      dispatch({
        type: CONSTANTS.GET_USER_INFO_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: CONSTANTS.GET_USER_INFO_FAILURE,
        payload: [],
      });
    }

    return response;
  } catch (error) {
    console.error("getUserInfo error:", error);
    dispatch({
      type: CONSTANTS.GET_USER_INFO_FAILURE,
      payload: [],
    });
    return { success: false, data: [] };
  }
};

export const getEditAgreementDetails = (agreementId) => async (dispatch) => {
  try {
    const response = await AuthService.getEditAgreementById(agreementId);

    if (response?.success) {
      dispatch({
        type: "GET_EDIT_AGREEMENT_SUCCESS",
        payload: response.data,
      });
      return response;
    } else {
      dispatch({
        type: "GET_EDIT_AGREEMENT_FAILURE",
        payload: null,
      });
      return response;
    }
  } catch (error) {
    console.error("getEditAgreementDetails error:", error);
    dispatch({
      type: "GET_EDIT_AGREEMENT_FAILURE",
      payload: null,
    });
    return { success: false, data: null };
  }
};

export const sendAgreementAction = (data) => async (dispatch) => {
  try {
    const response = await AuthService.sendAgreement(data);

    if (response?.success) {
      dispatch({
        type: "SEND_AGREEMENT_SUCCESS",
        payload: response.data,
      });
      return response;
    } else {
      dispatch({
        type: "SEND_AGREEMENT_FAILURE",
        payload: null,
      });
      return response;
    }
  } catch (error) {
    dispatch({
      type: "SEND_AGREEMENT_FAILURE",
      payload: null,
    });
    return { success: false };
  }
};

//Action

export const downloadAgreementFile = (agreementId) => async (dispatch) => {
  try {
    const response = await AuthService.downloadAgreementFile(agreementId);
    return response; // no reducer update needed
  } catch (error) {
    console.error("Download File Error:", error);
    return null;
  }
};

/*=========== PREVIEW AGREEMENT ===========*/
export const previewAgreementAction = (agreementId) => async (dispatch) => {
  try {
    const response = await AuthService.previewAgreement(agreementId);

    if (response?.success) {
      dispatch({
        type: CONSTANTS.PREVIEW_AGREEMENT_SUCCESS,
        payload: response.data, // { url }
      });
      return response;
    } else {
      dispatch({
        type: CONSTANTS.PREVIEW_AGREEMENT_FAILURE,
        payload: null,
      });
      return response;
    }
  } catch (error) {
    console.error("previewAgreementAction error:", error);
    dispatch({
      type: CONSTANTS.PREVIEW_AGREEMENT_FAILURE,
      payload: null,
    });
    return { success: false };
  }
};